"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimPolyfill = void 0;
function trimPolyfill() {
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }
}
exports.trimPolyfill = trimPolyfill;
//# sourceMappingURL=trimPolyfill.js.map